module.exports = __webpack_public_path__ + "img/woman.8683cd5d.png";